<template>
  <div>
    <div class="home-bg">
      <div class="content">
        <h1 class="title">偕行星联</h1>
        <p class="sub_title">数字智能营销专家</p>
        <p class="content_text">
          偕行机构作为知名数字智能营销专家，立足⼤数据、⼈⼯智能等新⼀代信息技术，能力核心包括数据洞察能力，品牌引爆能力、精准收割能力、私域沉淀能力。
        </p>
        <!-- <div class="home-button">前往使用></div> -->

        <div class="home-card">
          <div class="home-card-item" style="background-color:#2989b9">
            <div><span class="icon">&#xe640;</span></div>
            <div>
              <p class="card-title">游戏&网服</p>
              <p class="card-desc">
                游戏广告服务商，多平台游戏广告服务商，网服广告服务商，数据洞察，内容种草，精准投流，营销策划
              </p>
            </div>
          </div>
          <div class="home-card-item" style="background-color:#1081b9">
            <div><span class="icon">&#xe61e;</span></div>
            <div>
              <p class="card-title">电商</p>
              <p class="card-desc">
                整合营销和品牌传播能力，电商效果转化能力，差异化竞争能力
              </p>
            </div>
          </div>
          <div class="home-card-item" style="background-color:#1081b9">
            <div><span class="icon">&#xe601;</span></div>
            <div>
              <p class="card-title">
                本地生活
              </p>
              <p class="card-desc">
                资源整合和内容输出能力，选品&小程序运营能力，KOL、KOC孵化能力
              </p>
            </div>
          </div>
          <div class="home-card-item" style="background-color:#2989b9">
            <div><span class="icon">&#xe60e;</span></div>
            <div>
              <p class="card-title">更多探索</p>
              <p class="card-desc">偕行星联远不止于此</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top:240px"></div>
    <div class="tip-wrap">
      <p class="tip-title">5大核心事业部</p>
      <p class="tip-desc">core business</p>
      <div class="line-wrap">
        <div class="line"></div>
        <img src="../assets/logo_b.png" />
        <div class="line"></div>
      </div>
    </div>
    <div class="bussiness-card">
      <div class="content">
        <div class="flex-item">
          <div class="buss-card-item card-item1">
            <div>游戏事业部</div>
          </div>
        </div>
        <div class="flex-item">
          <div class="buss-card-item card-item2">
            <div>电商交易事业部</div>
          </div>
          <div class="buss-card-item card-item3">
            <div>本地生活事业部</div>
          </div>
        </div>
        <div class="flex-item">
          <div class="buss-card-item card-item4">
            <div>整合营销事业部</div>
          </div>
          <div class="buss-card-item card-item5">
            <div>品牌事业部</div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top:140px"></div>
    <div class="tip-wrap">
      <p class="tip-title">覆盖6大城市</p>
      <p class="tip-desc">Covering cities</p>
      <div class="line-wrap">
        <div class="line"></div>
        <img src="../assets/logo_b.png" />
        <div class="line"></div>
      </div>
    </div>
    <div class="city-wrap">
      <div class="city-item">
        北京
      </div>
      <div class="city-item">
        杭州
      </div>
      <div class="city-item">
        福州
      </div>
      <div class="city-item">
        厦门
      </div>
      <div class="city-item">
        长沙
      </div>
      <div class="city-item">
        南昌
      </div>
    </div>
  </div>
</template>
<script>
export default {
  head () {
    return {
      title: '偕行星联,一站式优选流量技术服务提供商',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            '厦门偕行星联管理咨询有限公司是中国领先的流量技术服务提供商，致力于构建整合优质媒体资源的一站式广告生态系统'
        }
      ]
    }
  },
  data () {
    return {}
  },
  components: {},

  mounted () {},
  beforeDestroy () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
}
.home-bg {
  width: 100%;
  height: 600px;
  background-image: url('../assets/images/index/bg.jpg');
  .content {
    height: 600px;
    position: relative;
    color: #fff;
    padding-top: 120px;
    width: 100%;
    margin: 0 auto;
    max-width: 1200px;
    .title {
      color: #fff;
      font-size: 40px;
      margin-bottom: 10px;
    }
    .sub_title {
      font-size: 16px;
    }
    .content_text {
      max-width: 500px;
    }
    .home-button {
      margin-top: 40px;
      border: 2px solid #fff;
      width: 100px;
      height: 30px;
      border-radius: 30px;
      text-align: center;
      cursor: pointer;
      line-height: 26px;
      color: #fff;
      background-image: linear-gradient(to right, #a8d3e4, #0bb4c7);
    }
    .home-card {
      box-shadow: 2px 3px 3px #053b75;
      width: 800px;
      height: 280px;
      position: absolute;
      bottom: -140px;
      display: flex;
      flex-wrap: wrap;
      right: 0;
      color: #fff;
      .home-card-item {
        display: flex;
        width: 400px;
        height: 140px;
        align-items: center;
        .card-title {
          font-size: 18px;
          margin-bottom: 4px;
        }
        .icon {
          margin: 0 20px;
          font-family: 'iconFont';
          font-size: 40px;
          vertical-align: middle;
        }
      }
    }
  }
}
.tip-wrap {
  width: 100%;
  text-align: center;
  .tip-title {
    font-weight: 600;
    color: #000;
    font-size: 20px;
    margin-bottom: 10px;
  }
  .line-wrap {
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    .line {
      width: 200px;
      height: 1px;
      background-color: #999;
    }
    img {
      width: 30px;
    }
  }
}
.bussiness-card {
  margin: 30px 0;
  width: 100%;
  background-color: #373a41;
  .content {
    height: 600px;
    color: #fff;
    width: 100%;
    margin: 0 auto;
    max-width: 1200px;
    display: flex;
    .flex-item {
      flex: 1;
    }
    .buss-card-item {
      width: 100%;
      height: 300px;
      background-repeat: no-repeat;
      background-size: cover;
      cursor: pointer;
      &:hover > div {
        display: block;
      }
      > div {
        display: none;
        text-align: center;
        line-height: 300px;
        font-size: 30px;
        background-color: rgba($color: #000000, $alpha: 0.5);
      }
    }
    .card-item1 {
      background-image: url('../assets/images/index/pexels-jeshootscom-442576.jpg');

      height: 600px;
      > div {
        line-height: 600px;
      }
    }
    .card-item2 {
      background-position: center;
      background-image: url('../assets/images/index/dianshang.jpg');
    }
    .card-item3 {
      background-position: center;
      background-image: url('../assets/images/index/city.jpeg');
    }
    .card-item4 {
      background-position: center;
      background-image: url('../assets/images/index/yingxiao.jpg');
    }
    .card-item5 {
      background-position: center;
      background-image: url('../assets/images/index/品牌.jpg');
    }
  }
}
.city-wrap {
  margin: 40px auto;
  display: flex;
  width: 100%;
  max-width: 1200px;
  align-items: center;
  justify-content: space-around;
}
.city-item {
  width: 120px;
  height: 120px;
  border-radius: 120px;
  border: 2px solid #eee;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  line-height: 120px;
}
</style>
